/**
 * App ids are stored lower case and the backend compares them case-insensitively, so a deep link to
 * /app/Figma resolves the same app as /app/figma. Comparisons in this app are case-sensitive though, so an
 * id taken from the URL has to be canonicalised before it is matched against anything the API returned —
 * otherwise an installed app reads as not installed.
 */
export function canonicalAppId(appId?: string) {
  return appId ? appId.toLowerCase() : appId;
}
